import { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { FormField, FormLabel, FormInput, Button } from '../../ui';

interface ArrayFieldManagerProps {
  label: string;
  name: string;
  values: number[];
  onChange: (values: number[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

function ArrayFieldManager({
  label,
  name,
  values,
  onChange,
  placeholder = 'Digite um ID',
  disabled = false,
}: ArrayFieldManagerProps) {
  const [newValue, setNewValue] = useState<string>('');

  const handleAdd = () => {
    const numValue = parseInt(newValue, 10);
    if (!isNaN(numValue) && numValue > 0 && !values.includes(numValue)) {
      onChange([...values, numValue]);
      setNewValue('');
    }
  };

  const handleRemove = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <FormField>
      <FormLabel>{label}</FormLabel>

      {/* Input para adicionar novos valores */}
      <div className="flex gap-2 mb-3">
        <FormInput
          type="number"
          min="1"
          placeholder={placeholder}
          value={newValue}
          onChange={e => setNewValue(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          className="flex-1"
        />
        <Button
          type="button"
          onClick={handleAdd}
          disabled={disabled || !newValue || isNaN(parseInt(newValue, 10))}
          size="sm"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      {/* Lista de valores existentes */}
      {values.length > 0 ? (
        <div className="space-y-2">
          {values.map((value, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-800 rounded-md"
            >
              <span className="text-sm font-medium">ID: {value}</span>
              {!disabled && (
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => handleRemove(index)}
                  className="text-red-600 hover:text-red-700"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-3 text-gray-500 text-sm border border-dashed rounded-md">
          Nenhum ID adicionado
        </div>
      )}

      {/* Hidden inputs para envio do formulário */}
      {values.map((value, index) => (
        <input key={index} type="hidden" name={`${name}[${index}]`} value={value} />
      ))}
    </FormField>
  );
}

export default ArrayFieldManager;
